// Storage migration - must be imported before any zustand stores
// This clears stale localStorage keys from before multi-tenant migration

const MIGRATION_VERSION = 4
const MIGRATION_KEY = 'ispot-migration-version'

const currentVersion = parseInt(localStorage.getItem(MIGRATION_KEY) || '0', 10)

if (currentVersion < MIGRATION_VERSION) {
  console.log(`Running storage migration from v${currentVersion} to v${MIGRATION_VERSION}`)
  console.log('Clearing all localStorage...')

  // Nuclear option: clear everything
  localStorage.clear()

  // Mark migration as complete
  localStorage.setItem(MIGRATION_KEY, String(MIGRATION_VERSION))
  console.log('Storage migration complete - all data cleared')
}

export {}
